/* jshint esversion: 6 */

import Vue from 'vue';
import VueRouter from 'vue-router'
import VueYandexMetrika from 'vue-yandex-metrika-ts';

// Yandex Metrika
const useYandexMetrika = process.env.VUE_APP_YANDEX_METRIKA_ID !== "";

if (useYandexMetrika) {
    Vue.use(VueYandexMetrika, {
        id: process.env.VUE_APP_YANDEX_METRIKA_ID,
        env: 'production'
    });
}
export const yandexMetrika = {
    name: 'yandex-metrika',

    methods: {
        sendToYandexMetrikaTtSendTwoStep: function() {
            (this as any).$metrika && (this as any).$metrika.reachGoal('t_tender-step2');
        },
        sendToYandexMetrikaTtCreateRequest: function() {
            (this as any).$metrika && (this as any).$metrika.reachGoal('t_tender-request');
        },
        sendToYandexMetrikaTtRegistration: function() {
            (this as any).$metrika && (this as any).$metrika.reachGoal('t_tender-registration');
        },
        sendToYandexMetrikaTtAuthorization: function() {
            (this as any).$metrika && (this as any).$metrika.reachGoal('t_tender-authorization');
        },
        sendToYandexMetrikaTtCreated: function() {
            (this as any).$metrika && (this as any).$metrika.reachGoal('t_tender-created');
        }
    }
};